<div class="p-3">
	<div class="row row-sigef">
		<my-col-dropdownlist selectFirstInput #Alimento [parent]="componente" [key]="'Producto'" [tabindex]="tabindex" [labelName]="'Producto'" [required]="true"></my-col-dropdownlist>
	</div>

	<div class="row row-sigef">
		<my-col-input #Cantidad [tabindex]="tabindex + 1" #CantReal [mask]="'#,# Kg'" [decimals]="0" [labelName]="'Cantidad'" [allowCero]="false" [required]="true"></my-col-input>
	</div>

	<div class="row row-sigef">
		<my-col-input #Precio [tabindex]="tabindex + 2" [mask]="'c2'" [parent]="componente" [labelName]="'Precio por Kg'" [required]="true" [allowCero]="false"></my-col-input>
	</div>

	<div class="row row-sigef">
		<my-col-dropdownlist #Almacen [parent]="componente" [key]="'Almacen'" [tabindex]="tabindex + 3" [labelName]="'Almacen'" [required]="true"></my-col-dropdownlist>
	</div>

	<my-row-expand class="row row-sigef pt-3" [tabindex]="tabindex + 4" [title]="Observaciones" [hint]="'Seleccione esta opción para incluir una aclaración adicional'" [labelName]="'Observaciones'" [expanded]="adicionalesVisible" (onExpand)="adicionalesVisible=$event"></my-row-expand>
	<div class="row" [ngClass]="{'d-none': !adicionalesVisible}">
		<my-col-textarea [tabindex]="tabindex + 5" [labelName]="'Observaciones'" [rows]="2" [labelVisible]="false" class="w-100"></my-col-textarea>
	</div>

	<div class="ml-1 mr-3 pl-3 mt-3 row" [ngClass]="{'d-none': openedInDialog}">
		<my-group-save-buttons [tabindex]="tabindex + 6" class="w-100" [saving]="saving" [targetName]="'Producto'"
							   (onSave)="onProductoSave($event)" (onCancel)="onProductoCancel($event)"></my-group-save-buttons>
	</div>
</div>
<my-message-dialog></my-message-dialog>
